export default function CTASection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        {/* Image container */}
        <div className="w-full max-w-2xl mx-auto mb-10 rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Fashion%20product%20photography%20with%20sneakers%20bag%20and%20accessories%20on%20warm%20cream%20backdrop%20with%20soft%20coral%20accents%2C%20minimalist%20composition%2C%20gentle%20film%20grain%20texture%2C%20editorial%20quality%2C%20modern%20ecommerce%20aesthetic%2C%20clean%20stylish%20display&width=1200&height=700&seq=cta-img-main-01&orientation=landscape"
            alt="GTBuy Spreadsheet products"
            className="w-full h-auto object-cover"
          />
        </div>

        {/* Text */}
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-3">
          Start Using <span className="italic text-primary-500">GTBuy Spreadsheet</span>
        </h2>
        <p className="text-base text-foreground-500 mb-8 max-w-lg mx-auto">
          Join thousands of users who have upgraded their product sourcing workflow
        </p>

        {/* CTA Button */}
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex px-10 py-4 rounded-full bg-foreground-900 text-background-50 font-medium text-base hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
        >
          Buy It Now
        </a>
      </div>
    </section>
  );
}